import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";

import i18n from "@/shared/lib/i18n";
import { initSentry } from "@/shared/lib/sentry";

import { router } from "./router";

initSentry();

// Регистрация минимального SW для PWA installability
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // SW не зарегистрировался — не критично
    });
  });
}

const root = createRoot(document.getElementById("root")!);

const renderApp = () => {
  root.render(
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={router} />
      </I18nextProvider>
    </StrictMode>,
  );
};

if (!i18n.isInitialized) {
  i18n.on("initialized", renderApp);
} else {
  renderApp();
}
